import Bar from './bar';

const SearchBar = props => {
  return <Bar {...props} />;
};

export default SearchBar;
